/**
 * @aiPurpose tab-local "have I already played the alert sound for this
 *   unread cycle?" cursor (#1073). Keyed by the target triple
 *   `(entityType, entityId, notificationType)` — the same grouping the
 *   server uses to UPSERT the aggregate row. A `kind: 'viewed'`
 *   realtime event resets the cursor for the matching key so the next
 *   `kind: 'updated'` for the same target can play again.
 * @aiInvariant module-level singleton — one Set per tab. Cross-tab
 *   dedup is intentionally NOT a v1 requirement (issue #1073), so two
 *   open tabs may both ring once.
 */
import type { NotificationEntityType, NotificationType } from '@magimp/shared';

const played = new Set<string>();

export function soundCursorKey(
  entityType: NotificationEntityType,
  entityId: string,
  notificationType: NotificationType,
): string {
  return `${entityType}:${entityId}:${notificationType}`;
}

export function hasPlayedFor(key: string): boolean {
  return played.has(key);
}

export function markPlayedFor(key: string): void {
  played.add(key);
}

export function resetPlayedFor(key: string): void {
  played.delete(key);
}

/** Test-only escape hatch. Not exported from the feature barrel. */
export function __resetAllPlayedSoundCursors(): void {
  played.clear();
}
